import axios from 'axios'

const baseURL = import.meta.env.MODE === 'development'
  ? `http://${window.location.hostname}:${import.meta.env.VITE_SOCKET_PORT}`
  : `https://${import.meta.env.VITE_SOCKET_HOST}`

const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  }
})

export default apiClient